module.exports = __webpack_public_path__ + "img/code_connexion.6dda08b6.png";